import React from 'react';
import { useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import type { Role, UseQueryWrapper } from '../../../types';

import type { GetRolesParams } from '../../../Domain/Users/Services';
import { roleService } from '../../../Domain/Users/Services';

import { useSnakeBar } from '../../useSnakeBar';

export type GetRolesQueryVariables = GetRolesParams;

export type GetRolesQueryResultData = {
  data: Array<Role>;
  totalCount: number;
};

const queryFn = (variables?: GetRolesQueryVariables) => async () => {
  const response = await roleService.getRoles(variables);
  return (response as AxiosResponse).data;
};

const QUERY_KEY = 'getRoles';

export const useRoleGetRolesQuery: UseQueryWrapper<GetRolesQueryResultData, GetRolesQueryVariables, false> = ({
  variables,
  options,
}) => {
  const { showErrorSnakeBar } = useSnakeBar();

  const onError = React.useCallback(() => {
    showErrorSnakeBar({ method: QUERY_KEY });
  }, [showErrorSnakeBar]);

  const select = React.useCallback(data => {
    return {
      data: data['hydra:member'],
      totalCount: data['hydra:totalItems'],
    };
  }, []);

  return useQuery<GetRolesQueryResultData>([QUERY_KEY, ...Object.values(variables || {})], queryFn(variables), {
    select,
    onError,
    ...(options || {}),
  });
};
